var _componentUniform = function($context) {
    if (!$().uniform) {
        console.warn('Warning - uniform.min.js is not loaded.');
        return;
    }

    // Initialize
    ($context instanceof jQuery ? $context.find('.form-input-styled') : $('.form-input-styled')).uniform({
        fileButtonClass: 'action btn bg-primary',
        fileButtonHtml: 'Datei auswählen',
        fileDefaultHtml: 'Keine Datei ausgewählt'
    });
};

var _uniformFileInputUpdate = function() {
    $(document).on('change', '.form-input-styled[type="file"]', function() {
        var $this = $(this);
        $this.siblings('.filename').html($this.val().replace('C:\\fakepath\\', ''));
    });
};

var _componentSelect2 = function($context) {
    if (!$().select2) {
        console.warn('Warning - select2.min.js is not loaded.');
        return;
    }

    // Initialize
    var $select = ($context instanceof jQuery ? $context.find('.form-control-select2') : $('.form-control-select2')).select2({
        minimumResultsForSearch: Infinity
    });

    // Trigger value change when selection is made
    $select.on('change', function() {
        $(this).trigger('blur');
    });
};

var _componentCiForms = function($context) {
    const $staticForms = $context instanceof jQuery ? $context.find('.js-ci-forms') : $('.js-ci-forms');

    if ($staticForms.length) {
        import(ICUBE_FORMS).then(() => {
            $staticForms.icubeForm({
                fieldValid: function({ $field, settings }) {
                    const $uniformSelect = $field.closest('.uniform-select');

                    if ($uniformSelect.length) {
                        $uniformSelect.removeClass(settings.fieldErrorClassname);
                    }
                },
                fieldInvalid: function({ $field, settings }) {
                    const $uniformSelect = $field.closest('.uniform-select');

                    if ($uniformSelect.length) {
                        $uniformSelect.addClass(settings.fieldErrorClassname);
                    }
                },
                formInvalid: function($form) {
                    $form.find('.CIF-Errors').fadeIn();

                    return false;
                },
                beforeInit: function($form) {
                    $form.find('.js-icube-cloner').each(function() {
                        GlobalCloner.init($(this));
                    });
                }
            });
        });
    }
};

function init($context) {
    _componentUniform($context);
    _componentSelect2($context);
    _componentCiForms($context);
    _uniformFileInputUpdate();
}

export const FormValidation = {
    init
}